/**
 * EN-893 — single source of truth for how to reach HappyDoc support.
 *
 * KEEP IN SYNC: the Intercom messenger has its own office-hours and expected-reply
 * settings configured in the Intercom admin UI. This file is the source of truth for
 * what the app displays; Intercom is a manual mirror. Change both.
 */

/** Dialable form, for `tel:` hrefs. */
export const SUPPORT_PHONE_E164 = "+17206150059";

/** Human-readable form, for display. */
export const SUPPORT_PHONE_DISPLAY = "(720) 615-0059";

/**
 * The one correct support address. Imported rather than hardcoded at call sites
 * because the app had drifted into two spellings (`support@happydoc.com` in checkout
 * and bridge troubleshooting, `support@happydoc.ai` in auth).
 */
export const SUPPORT_EMAIL = "support@happydoc.ai";

/**
 * Phone and chat are both staffed these hours (Denver office); after hours chat is
 * best-effort only. Stated in Mountain time rather than converted to the viewer's
 * zone — matches how other SaaS products state support hours in-product.
 */
export const SUPPORT_HOURS_SHORT = "Mon–Fri, 9am–4pm MT";

/**
 * Whether this device can plausibly place a call, i.e. whether `tel:` is worth
 * rendering. Coarse pointer is the closest proxy for "phone or tablet"; on a desktop
 * a `tel:` link is a dead end, so the number stays plain selectable text that can be
 * copied into a softphone.
 *
 * Marked up deliberately rather than left to the OS: iOS Safari auto-linkifies
 * plausible phone-number strings in plain text with no markup at all, so the number
 * is tappable on an iPad regardless. Owning the markup means owning the styling.
 */
export const canDialFromThisDevice = (): boolean => {
    try {
        return window.matchMedia?.("(pointer: coarse)").matches ?? false;
    } catch {
        return false;
    }
};
